export default {
    home: 'home',
    taxdocuments: 'tax-documents',
    pensionverification: 'pension-verification',
} as const;
